import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useDebouncedState } from './useDebouncedState.ts';


export function useRecordsFilters() {
    const [searchParams, setSearchParams] = useSearchParams();
    const searchTextInUrl = searchParams.get('search') ?? '';
    const onlyWithIssuesInUrl = searchParams.get('onlyWithIssues') === 'true';

    const [onlyWithIssues, setOnlyWithIssues] = useState<boolean>(onlyWithIssuesInUrl);


    const {
        runningValue: searchTextInput,
        debouncedValue: searchText,
        setValueDebounced: setSearchTextDebounced,
        setValueImmediate: setSearchTextImmediate,
    } = useDebouncedState<string>(searchTextInUrl, 200, handleSearchTextChanged);

    useEffect(() => {
        setSearchTextImmediate(searchTextInUrl);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTextInUrl]);

    function handleSearchTextChanged(text: string) {
        setSearchParams(prevParams => {
            const newParams = new URLSearchParams(prevParams);
            if (text) newParams.set('search', text);
            else newParams.delete('search');
            return newParams;
        }, { replace: true });
    }

    function handleOnlyWithIssuesChanged(value: boolean) {
        setOnlyWithIssues(value);
        setSearchParams(prevParams => {
            const newParams = new URLSearchParams(prevParams);
            if (value) newParams.set('onlyWithIssues', 'true');
            else newParams.delete('onlyWithIssues');
            return newParams;
        }, { replace: true });
    }

    function handleClearFilters() {
        setSearchTextImmediate('');
        setOnlyWithIssues(false);
        setSearchParams(new URLSearchParams(), { replace: true });
    }

    return {
        searchTextInput,
        searchText,
        setSearchTextDebounced,
        setSearchTextImmediate,
        onlyWithIssues,
        setOnlyWithIssues: handleOnlyWithIssuesChanged,
        handleClearFilters,
    }
}
